import React, { Fragment, useContext, useEffect, useState } from 'react';
import bin from './bin.svg';
import { Button } from './Button';
import { Photo } from './Photo';
import { Video } from './Video';
import { VideoCarousel } from './VideoCarousel';
import { News } from './News';
import star from './star.svg';
import { Badge } from './Badge';
import { FirebaseContext } from './context';
import { doc, getDocs, query, collection, onSnapshot, getDoc, addDoc, setDoc, limit, orderBy } from 'firebase/firestore';
import { INews, IVideo, IUserProfile } from './models';
import moment from 'moment';
import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { logEvent } from 'firebase/analytics';
import { useNavigate } from 'react-router-dom';

export const PageHome = () => {
    const navigate = useNavigate();
    const { db, ui, user, auth, analytics } = useContext(FirebaseContext);
    const [ videos, setVideos ] = useState<IVideo[]>([]);
    const [ news, setNews ] = useState<INews[]>([]);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, '/v2-videos'), limit(6), orderBy('date', 'desc')), (snapshot) => {
                setVideos(snapshot.docs.map((doc) => {
                    return {...doc.data(), id: doc.id} as IVideo;
                }));
            });
        }
    }, [db]);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, '/v2-news'), limit(4), orderBy('date', 'desc')), (snapshot) => {
                setNews(snapshot.docs.map((doc) => {
                    return {...doc.data(), id: doc.id} as INews;
                }));
            });
        }
    }, [db]);
    return <div>
            <div className="flex justify-between px-36 py-20">
            <div className="flex flex-col justify-between">
                <div className="mb-5">
                    <p className="text-6xl mb-5">Какой-то там слоган</p>
                    <p className="text-xl text-gray-600">Что-нибудь про мусор и ещё что-нибудь</p>
                </div>
                <Button label="Узнать больше" primary={true} size='large' onClick={() => logEvent(analytics!, "check_section", {
                    content_type: 'main'
                })}/>
            </div>
            <img src={bin} alt="" className="w-200"/>
        </div>
        <div className="grid grid-cols-2 w-fit px-36 py-20">
            <div>
                <div className='w-fit'>
                    <Photo size='large' src='https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8Y2Fyc3xlbnwwfHwwfHw%3D&w=1000&q=80' />
                    <div className="-translate-y-full flex justify-between">
                        <div className="opacity-50 w-36 h-36 bg-[#01487C] rounded-full"></div>
                        <div className="flex flex-col justify-end">
                            <div className="w-20 h-20 bg-[#01487C] rounded-full -translate-x-1/4 -translate-y-1/4"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="max-w-xl">
                <div className="mb-5">
                    <p className="text-3xl mb-5">Важное мероприятие</p>
                    <p>Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen Lorem ipsum dolor sit amen </p>
                </div>
                <div className='mb-7 flex gap-10'>
                    <Badge image={star} size='middle' title='Звезда' />
                    <Badge image={star} size='middle' title='Звезда' />
                </div>
                <Button label="Lorem ipsum" size='large'/>
            </div>
        </div>
        <div className="bg-gray-200 px-10">
            <div className='text-center py-10'>
                <p className="text-4xl mb-5">Видео</p>
                <p className="text-lg">Смотрите видео с наших мероприятий здесь</p>
            </div>
            <VideoCarousel videos={videos.map((video) => {
                return {
                    id: video.id,
                    src: video.url,
                    title: video.title,
                    description: video.description
                }
            })} startAt={1}/>
            <div className="flex justify-center p-10">
                <Button label='Подробнее' onClick={() => logEvent(analytics!, "check_section", {
                    content_type: 'video'
                })}/>
            </div>
        </div>
        <div>
            <div className='text-center py-10'>
                <p className="text-4xl mb-5">Новости</p>
                <p className="text-lg">Наши последние новости</p>
            </div>
            <div className='px-36 flex flex-wrap space-x-10 justify-center'>
                {news.map((item) => <News key={item.id} id={item.id} image={item.image} title={item.title} description={item.description?.slice(0, 100) + (item.description && item.description.length > 100 ? '...' : '')} date={moment(item.date.toMillis()).fromNow()} />)}
            </div>
            <div className="flex justify-center p-10">
                <Button label='Подробнее' onClick={() => logEvent(analytics!, "check_section", {
                    content_type: 'news'
                })}/>
            </div>
        </div>
        <div className='bg-gray-200 px-10'>
            <div className='text-center py-10'>
                <p className="text-4xl mb-5">Заинтересованы?</p>
                <p>Создайте аккаунт</p>
                <Button label="Регистрация или вход" onClick={() => navigate('/me')}/>
            </div>
            {/* <div className="flex justify-center p-10">
                <Button label='Подробнее' />
            </div> */}
        </div>
    </div>
}